import { FC, ReactNode } from 'react';

import ErrorIcon from '@/assets/icons/Error';

import styles from './ErrorState.module.css';

type ErrorStateProps = {
  title?: string;
  description?: string;
  children?: ReactNode;
};

const ErrorState: FC<ErrorStateProps> = ({
  title = 'Er ging iets mis',
  description = 'Herlaad de pagina en probeer het opnieuw',
  children,
}) => {
  return (
    <div className={styles.errorStateStyle}>
      <ErrorIcon height='56px' width='56px' />
      <h2 className={styles.titleStyle}>{title}</h2>
      <p className={styles.descriptionStyle}>{description}</p>
      <div className={styles.subtextStyle}>
        <p>Wanneer dit niet helpt, neem dan contact op via het feedbackformulier.</p>
        <p>Zet de foutmelding erbij en wat er gebeurde.</p>
      </div>
      {children && <div className={styles.actionsStyle}>{children}</div>}
    </div>
  );
};

export default ErrorState;
